import { Injectable } from '@angular/core';
import { SetupParameterKindListViewModel } from 'chronos-basedata-client';
import { SetupParameterStore } from './setup-parameter.store';
import { Filters } from './setup-parameter.model';

@Injectable({ providedIn: 'root' })
export class SetupParameterService {
  constructor(private setupParameterStore: SetupParameterStore) {}

  public updateSetupParameter(setupParameterViewMOdel: SetupParameterKindListViewModel[]): void {
    this.setupParameterStore.setLoading(true);
    this.setupParameterStore.set(setupParameterViewMOdel);
    this.setupParameterStore.setLoading(false);
  }

  public updateSetupParameterItem(updateSetupParameter: Partial<SetupParameterKindListViewModel>): void {
    this.setupParameterStore.setLoading(true);
    this.setupParameterStore.update(updateSetupParameter);
    this.setupParameterStore.setLoading(false);
  }

  public updateFilters(filters: Filters): void {
    this.setupParameterStore.updateFilters(filters);
  }

  public resetFilters(): void {
    this.setupParameterStore.resetFilters();
  }
}
